/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  contract.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:29
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

const contractRouter = [
  {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    component: () =>
            import(/* webpackChunkName: "contract" */ '@/views/contract/privacyPolicy.vue'),
    meta: {
      title: '南瓜头平台隐私政策',
      deepth: 1
    },
  },
  {
    path: '/userAgreement',
    name: 'userAgreement',
    component: () =>
            import(/* webpackChunkName: "contract" */ '@/views/contract/userAgreement.vue'),
    meta: {
      // title: '飞算产业数智通平台注册协议',
      title: '南瓜头平台注册协议',
      // keepAlive: true,
      deepth: 1
    },
  },
  {
    path: '/about',
    name: 'About',
    component: () =>
            import(/* webpackChunkName: "contract" */ '@/views/contract/About.vue'),
    meta: {
      title: '简介',
      // keepAlive: true,
      deepth: 1
    },
  },
  {
    path: '/messageProtect',
    name: 'MessageProtect',
    component: () =>
            import(/* webpackChunkName: "contract" */ '@/views/contract/MessageProtect.vue'),
    meta: {
      title: '个人信息保护提示',
      deepth: 1
    },
  },
  {
    path: '/logOff',
    name: 'LogOff',
    component: () =>
            import(/* webpackChunkName: "contract" */ '@/views/contract/LogOff.vue'),
    meta: {
      title: '注销账号',
      deepth: 1
    },
  }
]

export default contractRouter
